import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, FormGroup } from '@angular/forms';
import {CustomValidationService} from '../services/custom-validation.service';

@Directive({
  selector: '[matchNip]',
  providers: [{ provide: NG_VALIDATORS, useExisting: MatchNipDirective, multi: true }]
})
export class MatchNipDirective implements Validator {
  @Input('matchNip') MatchNip: string[] = [];

  constructor(private customValidator: CustomValidationService) { }

  validate(formGroup: FormGroup): ValidationErrors {
    return this.customValidator.MatchNip(this.MatchNip[0], this.MatchNip[1])(formGroup);
  }
}
